import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Mail } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const Footer = () => {
  const { t, language } = useLanguage();
  const { toast } = useToast();
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: t('common.subscribed'),
        description: t('common.subscribedMessage'),
      });
      setEmail('');
    }
  };

  return (
    <footer id="contact" className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      {/* Newsletter Section */}
      <div className="border-b border-gray-700">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold mb-2">{t('newsletter.title')}</h3>
            <p className="text-gray-400">{t('newsletter.description')}</p>
          </div>
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <div className="flex-1 relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <Input
                type="email"
                placeholder={t('newsletter.placeholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-10 bg-white/10 border-gray-600 text-white placeholder:text-gray-400 focus:border-blue-400"
              />
            </div>
            <Button type="submit" className="bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 hover:from-blue-700 hover:to-cyan-600">
              {t('newsletter.button')}
            </Button>
          </form>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Menu */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.menu')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#home" className="hover:text-blue-400 transition-colors">{t('nav.home')}</a></li>
              <li><a href="#create" className="hover:text-blue-400 transition-colors">{t('nav.create')}</a></li>
              <li><a href="#examples" className="hover:text-blue-400 transition-colors">{t('nav.examples')}</a></li>
              <li><a href="#faq" className="hover:text-blue-400 transition-colors">{t('nav.reviews')}</a></li>
            </ul>
          </div>

          {/* Service */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.service')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="mailto:contact@trakz-studio.com" className="hover:text-blue-400 transition-colors">{t('nav.contact')}</a></li>
              <li><a href="#faq" className="hover:text-blue-400 transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.info')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href={`/${language}/terms`} className="hover:text-blue-400 transition-colors">{t('footer.terms')}</a></li>
              <li><a href={`/${language}/privacy`} className="hover:text-blue-400 transition-colors">{t('footer.privacy')}</a></li>
              <li><a href={`/${language}/refund`} className="hover:text-blue-400 transition-colors">{t('footer.refund')}</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
          <p>&copy; 2025 TRAKZVIBE. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
